import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import { ARIST_TAG_STYLE, ARIST_TAG_CATEGORY } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"

const ArtistOverview: FunctionComponent = () => {
  return (
    <div className="scrollable container">
      <FormInput
        label="Name"
        name={"name"}
        validation={{ required: "This field is required!" }}
      />
      <Controller as={Textarea} name="bio" label="Biography" />
      <FormInput label="Country" name={"country"} />
      <AsyncCreatableTag
        name="category"
        label="Category"
        group={ARIST_TAG_CATEGORY}
      />
      <AsyncCreatableTag name="style" label="Style" group={ARIST_TAG_STYLE} />
      <div className="row">
        <div className="col-4">
          <FormInput
            name="birth.day"
            label="Day of Birth"
            placeholder="E.g. 03 or 22"
            validation={{
              pattern: {
                value: /^(0[1-9])|([1-2][0-9])|(3[0-1])$/,
                message: "Invalid format, must have 2 digits",
              },
            }}
          />
        </div>
        <div className="col-4">
          <FormInput
            name="birth.month"
            label="Month of Birth"
            placeholder="E.g. 05"
            validation={{
              pattern: {
                value: /^(0[1-9])|(1[0-2])$/,
                message: "Invalid format, must have 2 digits",
              },
            }}
          />
        </div>
        <div className="col-4">
          <FormInput
            name="birth.year"
            label="Year of Birth"
            placeholder="E.g. 1953"
            validation={{
              pattern: {
                value: /^[0-9]+$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
      <FormInput
        label="Is birthday private?"
        name="birth.isHidden"
        type="checkbox"
      />
    </div>
  )
}

export default ArtistOverview
